import React from "react";
import { Box, Container, Typography, useTheme, useMediaQuery } from "@mui/material";
import Vision from "../assets/Vision.png";

export default function VisionSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        overflow: "hidden",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 5, md: 8 },
        }}
      >
        {/* === Left Text Content === */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
            maxWidth: 600,
            mx: "auto",
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            mb={2}
            sx={{
              background: "linear-gradient(90deg, #1565c0, #004ba0)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our Vision
          </Typography>

          <Typography
            variant="h6"
            color="primary"
            mb={3}
            sx={{ opacity: 0.9 }}
          >
            (NAMAMI Integrated Facilities Management)
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: 1.8,
              fontSize: "1.05rem",
              mb: 3,
            }}
          >
            We combine <strong>professional expertise, modern technology</strong>, and a
            <strong> dedicated workforce</strong> to deliver seamless solutions that exceed
            client expectations and set new benchmarks in the facility management industry.
          </Typography>

          <Box
            sx={{
              mt: 3,
              p: 3,
              background: "linear-gradient(135deg, #ffffff, #f1f8ff)",
              borderRadius: 3,
              boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
              borderLeft: "5px solid #1976d2",
            }}
          >
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              At <strong>Namami India Support Services</strong>, our mission is to redefine
              Integrated Facilities Management through sustainable practices, smart technology
              adoption, and a people-first approach that enhances operational efficiency across
              every service vertical.
            </Typography>
          </Box>
        </Box>

        {/* === Right Image === */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={Vision}
            alt="Namami India Vision"
            sx={{
              width: { xs: "80%", sm: "70%", md: "90%" },
              maxWidth: 480,
              borderRadius: 3,
              filter: "drop-shadow(0px 6px 12px rgba(0,0,0,0.15))",
              transition: "transform 0.5s ease",
              "&:hover": {
                transform: isMobile ? "none" : "scale(1.05)",
              },
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
